import { Text } from '@thanx/uikit/text'
import { Role } from 'api/roles'
import Section from 'components/Section'
import { buildTranslate } from 'locales'

const t = buildTranslate('merchant_users.rbac.info_banner')

type Props = {
  roles: Role[]
  locationIds: number[]
}

export const RbacRoleInfoBanner = ({ roles, locationIds }: Props) => {
  if (roles.length === 0) return null

  const isGlobal = locationIds.length === 0

  return (
    <Section className="p-l mt-m" kind="secondary">
      <div className="d-flex align-items-start">
        <i
          className="fa fa-lock mr-s grey-50 font-size-20"
          aria-hidden="true"
        />
        <div>
          <Text.Header4 className="m-0">
            {isGlobal ? t('global_title') : t('local_title')}
          </Text.Header4>
          <Text.BodyText4 color="grey70">
            {isGlobal ? t('global_description') : t('local_description')}
          </Text.BodyText4>
        </div>
      </div>
    </Section>
  )
}
